import DeliveryDriversView from "../../../views/DeliveryDrivers/DeliveryDriversHome";
import DeliveryDriversDetail from "../../../views/DeliveryDrivers/DeliveryDriversDetail";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const DeliveryDriversRoutes = [
  {
    menuName: MenuNames.DRIVER,
    path: "/delivery-drivers",
    component: DeliveryDriversView,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER,
    path: "/delivery-drivers/:id/:detailType",
    component: DeliveryDriversDetail,
    exact: true,
  },
];

export default DeliveryDriversRoutes;
